import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/Base.scss";
import MainLayout from "./components/MainLayout";
import "./styles/Base.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import HomePage from "./pages/HomePage";
import MarkdownPage from "./pages/MarkdownPage";
import ThemeProvider from "./styles/theme/ThemeProvider";
import { SnackbarProvider } from "notistack";
import BibliographyRouter from "./pages/bibliographies/BibliographyRouter";
import ColophonRouter from "./pages/colophons/ColophonRouter";
import { SystemEntityCollections } from "./shared/enums/shared-enums";
import { RoutesLogic } from "./common/entities/routesLogic";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import TextRouter from "./pages/texts/TextRouter";
import VersionRouter from "./pages/versions/VersionRouter";
import PlaceRouter from "./pages/places/PlaceRouter";
import WorkRouter from "./pages/works/WorkRouter";
import PersonRouter from "./pages/persons/PersonRouter";
import TeamRouter from "./pages/teams/TeamRouter";
import PageNotFound from "./pages/PageNotFound";
import CodeRouter from "./pages/codes/CodeRouter";

const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <Router
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          <SnackbarProvider maxSnack={3}>
            <Routes>
              {/* Main Application Routes with MainLayout */}
              <Route path="/" element={<MainLayout />}>
                {/* Text-Related Routes */}
                <Route path="" element={<HomePage />} />
                {/* Version-Related Routes */}
                <Route
                  path={RoutesLogic.getMainRoute(
                    SystemEntityCollections.VERSION
                  )}
                  element={<VersionRouter />}
                />
                {/* Person-Related Routes */}
                <Route
                  path={RoutesLogic.getMainRoute(
                    SystemEntityCollections.PERSON
                  )}
                  element={<PersonRouter />}
                />
                {/* Colophon-Related Routes */}
                <Route
                  path={RoutesLogic.getMainRoute(
                    SystemEntityCollections.COLOPHON
                  )}
                  element={<ColophonRouter />}
                />
                {/* Bibliography-Related Routes */}
                <Route
                  path={RoutesLogic.getMainRoute(
                    SystemEntityCollections.BIBLIOGRAPHY
                  )}
                  element={<BibliographyRouter />}
                />
                {/* Text-Related Routes */}
                <Route
                  path={RoutesLogic.getMainRoute(SystemEntityCollections.TEXT)}
                  element={<TextRouter />}
                />
                {/* Team-Related Routes */}
                <Route
                  path={RoutesLogic.getMainRoute(SystemEntityCollections.TEAM)}
                  element={<TeamRouter />}
                />
                {/* Work-Related Routes */}
                <Route
                  path={RoutesLogic.getMainRoute(SystemEntityCollections.WORK)}
                  element={<WorkRouter />}
                />
                {/* places-Related Routes */}
                <Route
                  path={RoutesLogic.getMainRoute(SystemEntityCollections.PLACE)}
                  element={<PlaceRouter />}
                />
                {/* user-enum-Related Routes */}
                <Route
                  path={RoutesLogic.getMainRoute(SystemEntityCollections.USER_ENUM)}
                  element={<CodeRouter />}
                />
                <Route path="/markdown" element={<MarkdownPage />} />
                {/* Catch-All Route for 404 */}
                <Route path="*" element={<PageNotFound />} />
              </Route>
            </Routes>
          </SnackbarProvider>
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
